import React from 'react';

export default function Experiments() {
    return (
        <div>
            <h1 class='mt-5'>Experiments</h1> 
        </div>
    );
}